import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section, SectionTitle } from '../Section';
import { CtaBlock } from '../CtaBlock';
import { testimonials } from '../../data/content';
export function Testimonials() {
  return <Section data-id="element-238" data-mp="3mg0oetkr55ik">
      <SectionTitle eyebrow="⭐ What welders are saying" subtitle="Real experiences from the workshop" data-id="element-239" data-mp="3mfhg84kwlvhq">
        Welders using the system
      </SectionTitle>

      <ul className="mt-8 grid gap-4 lg:grid-cols-3" data-id="element-240" data-mp="fw8kndmpqo">
        {testimonials.map(t => <li key={t.name} className="flex flex-col rounded-2xl border border-white/10 bg-ink-800 p-5" data-id="element-241" data-mp="41rsva4o4b8d">
            <div className="flex items-center gap-3" data-id="element-242" data-mp="8zt6vgn8lkcz">
              <img src={t.image} alt={`${t.name}, ${t.role}`} className="h-14 w-14 shrink-0 rounded-full object-cover" width={112} height={112} data-id="element-243" data-mp="dzxq3efj4t6w" />
              <div className="min-w-0" data-id="element-244" data-mp="2fug9kosi2kkf">
                <p className="text-[15px] font-bold leading-tight text-white" data-id="element-245" data-mp="1sl2odziug025">
                  {t.name}
                </p>
                <p className="text-[13px] leading-tight text-white/50" data-id="element-246" data-mp="1nt11zkryosye">
                  {t.role}
                </p>
                <div className="mt-1 flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-247" data-mp="1iuzkh4a6p1p1">
                  {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-ember text-ember" aria-hidden="true" data-id="element-248" data-mp="2bilxt497rkp3" data-mpi={i} />)}
                </div>
              </div>
            </div>
            <blockquote className="mt-4 text-[15px] leading-relaxed text-white/75" data-id="element-249" data-mp="1xikm0treusuu">
              “{t.quote}”
            </blockquote>
          </li>)}
      </ul>

      <CtaBlock className="mt-10" headline="Join +1,200 welders using the system" data-id="element-250" data-mp="m4qkrix95pz6" />
    </Section>;
}